import { render, staticRenderFns } from "./productsNew.vue?vue&type=template&id=1ac91186&scoped=true"
import script from "./productsNew.vue?vue&type=script&lang=js"
export * from "./productsNew.vue?vue&type=script&lang=js"
import style0 from "./productsNew.vue?vue&type=style&index=0&id=1ac91186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac91186",
  null
  
)

export default component.exports